import React, { useState, useRef } from 'react';
import {
  CuentaComercios,
  Impulsa,
  Finanzas2,
  Administra,
  Calendario,
  Seguridad1,
  Contacto1
} from 'components/articles';
import Button from 'components/ui/button';

import image from 'assets/images/main-micro.jpg';

export default function MicroEmprendimiento() {
  const inputRef = useRef(null);
  const [article, setArticle] = useState(null);
  const variant = "micro";

  const selectArticle = (item) => {
    setArticle(item);
    const scrollto = inputRef.current.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({ top: scrollto, behavior: 'smooth' });
  }

  return (
    <div className={`wrapper ${variant}`}>
      <div className="content-cols">
        <figure>
          <img src={image} alt="¿Sos microemprendedor/a?" />
          <figcaption>¿Sos<br />microemprendedor/a?</figcaption>
        </figure>
        <section className='segment-nav'>
          <Button
            article='cuenta-comercios'
            active={article === 'cuenta-comercios'}
            onclick={() => selectArticle('cuenta-comercios')}
            variant={variant}
          />
          <Button
            article='impulsa'
            active={article === 'impulsa'}
            onclick={() => selectArticle('impulsa')}
          />
          <Button
            article='finanzas'
            active={article === 'finanzas'}
            onclick={() => selectArticle('finanzas')}
          />
          <Button
            article='administra'
            active={article === 'administra'}
            onclick={() => selectArticle('administra')}
            variant={variant}
          />
          <Button
            article='calendario'
            active={article === 'calendario'}
            onclick={() => selectArticle('calendario')}
          />
          <Button
            article='seguridad'
            active={article === 'seguridad'}
            onclick={() => selectArticle('seguridad')}
          />
          <Button
            article='contacto'
            active={article === 'contacto'}
            onclick={() => selectArticle('contacto')}
          />
        </section>
      </div>
      <div ref={inputRef}>
        {article &&
          <article>
            {article === 'cuenta-comercios' && <CuentaComercios />}
            {article === 'impulsa' && <Impulsa />}
            {article === 'finanzas' && <Finanzas2 />}
            {article === 'administra' && <Administra variant={variant} />}
            {article === 'calendario' && <Calendario variant={4} />}
            {article === 'seguridad' && <Seguridad1 variant={variant} />}
            {article === 'contacto' && <Contacto1 />}
          </article>
        }
      </div>
    </div>
  );
}